import {
  getTableData,
  saveFunction,
  getFunctionDetail,
  updateFunction,
  getDliteFunction,
  getBevolClaim
} from '@/axios/api/bevolFunction'

const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_DLITE_FUNCTION = 'UPDATE_DLITE_FUNCTION'
const UPDATE_BEVOL_CLAIM = 'UPDATE_BEVOL_CLAIM'
const UPDATE_ALL_BEVOL_CLAIM = 'UPDATE_ALL_BEVOL_CLAIM'

const state = {
  tableData: [],
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  detail: {},
  dliteFunction: [],
  bevolClaim: [],
  allBevolClaim: []
}

const getters = {
  tableData: state => state.tableData.map(v => {
    return {
      ...v,
      dataStatusText: v.dataStatus === 2 ? window.$lang('txt.yes') : window.$lang('txt.no')
    }
  }),
  pager: state => state.pager,
  detail: state => {
    const functionIdList = state.detail.dliteFunctionIds ? state.detail.dliteFunctionIds.split(',').map(v => Number(v)) : []
    return {
      ...state.detail,
      functionIdList
    }
  },
  dliteFunction: state => state.dliteFunction,
  bevolClaim: state => state.bevolClaim,
  allBevolClaim: state => state.allBevolClaim
}

const mutations = {
  [UPDATE_TABLE_DATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = { ...state.pager, ...pager }
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_DLITE_FUNCTION] (state, dliteFunction) {
    state.dliteFunction = dliteFunction
  },
  [UPDATE_BEVOL_CLAIM] (state, bevolClaim) {
    state.bevolClaim = bevolClaim
  },
  [UPDATE_ALL_BEVOL_CLAIM] (state, allBevolClaim) {
    state.allBevolClaim = allBevolClaim
  }
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({ commit }, params) {
    try {
      const { data: res } = await getTableData(params)
      commit(UPDATE_TABLE_DATA, res.records)
      commit(UPDATE_PAGER, { total: res.total })
    } catch (e) {}
  },
  // 设置pager
  setPagerApi ({ commit }, params) {
    commit(UPDATE_PAGER, params)
  },
  // 新增
  async addFunctionApi ({ commit }, params) {
    try {
      const res = await saveFunction(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 编辑
  async editFunctionApi ({ commit }, params) {
    try {
      const res = await updateFunction(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 详情
  async getDetailApi ({ commit }, params) {
    try {
      const { data: res } = await getFunctionDetail(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
  },
  // 模糊搜索dlite function信息
  async getDliteFunctionApi ({ commit }, params) {
    try {
      const { data: res } = await getDliteFunction(params)
      commit(UPDATE_DLITE_FUNCTION, res || [])
    } catch (e) {}
  },
  // 模糊搜索bevol claim信息
  async getBevolClaimApi ({ commit }, params) {
    try {
      // dataStatus 代表Show as function claim 为yes的数据
      const { data: res } = await getBevolClaim({...params, dataStatus: 2})
      commit(UPDATE_BEVOL_CLAIM, res || [])
    } catch (e) {}
  },
  // 所有bevol claim
  async getAllBevolClaimApi ({ commit }) {
    try {
      // dataStatus 代表Show as function claim 为yes的数据
      const { data: res } = await getBevolClaim({ keyword: '', dataStatus: '' })
      commit(UPDATE_ALL_BEVOL_CLAIM, res || [])
    } catch (e) {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/bevolFunction.js